import type { MenuDisplayMode } from '../types.js';

export const getMenuTriggerDisplayMode = (interactionsConfig: {
  isPanEnabled: boolean | undefined;
  isZoomEnabled: boolean | undefined;
  isDownloadEnabled: boolean;
}): MenuDisplayMode => {
  const { isDownloadEnabled, isPanEnabled, isZoomEnabled } = interactionsConfig;

  if (isPanEnabled || isZoomEnabled) {
    if (isZoomEnabled || isDownloadEnabled) {
      return 'always';
    } else {
      return 'expanded';
    }
  } else if (isDownloadEnabled) {
    return 'collapsed';
  } else {
    return 'never';
  }
};
